module.exports = __webpack_public_path__ + "img/ring_y_0_1_1@2x.c8ef1912.png";